import { css } from '@emotion/react'
import { Tabs } from 'bold-ui'
import { TabLink } from 'components/route'
import { TipoEnderecoEnum } from 'graphql/types.generated'
import { useLocation, useRouteMatch } from 'react-router'
import { tipoEnderecoIndigena } from 'view/cadastro-imovel/model-cadastroImovel'

interface VisualizarImovelHeaderTabsProps {
  tipoEndereco: TipoEnderecoEnum | undefined | null
  isStatusRecusaCadastro: boolean
}

export function VisualizarImovelHeaderTabs(props: VisualizarImovelHeaderTabsProps) {
  const { tipoEndereco, isStatusRecusaCadastro } = props
  const match = useRouteMatch()
  const { search } = useLocation()

  return (
    <Tabs
      style={css`
        margin-top: 0.5rem;
        border-bottom-width: 0;
      `}
    >
      <TabLink to={`${match.url}/informacoes${search}`}>Informações cadastrais</TabLink>
      {!isStatusRecusaCadastro && <TabLink to={`${match.url}/familias${search}`}>Famílias e moradores</TabLink>}
      {tipoEndereco && !tipoEnderecoIndigena.includes(tipoEndereco) && !isStatusRecusaCadastro && (
        <TabLink to={`${match.url}/visitas${search}`}>Últimas visitas</TabLink>
      )}
    </Tabs>
  )
}
